export default __webpack_public_path__ + "static/media/topViewExplanation.2f95a713.png";